/* Built-In Imports */
/* External Imports */
import { Box, Button, Center, Collapse, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import React, { useState } from 'react';
/* Internal Imports */
/* Components */
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@shi/Utility/StructuredTextParser';
import SadhanaContentSt from '@shi/styleData/SadhanaContentSt';
/* Style */
/* Services */
/**
 *
 * @param {Obj} tabContent
 * @param {Str} lang
 * @param {Str} region
 * @param {Bool} borderBottom
 * @returns {ReactElement} TabPanelCard
 */
const TabPanelCard = ({ tabContent, lang, region, borderBottom }) => {
  const [readMore, setReadMore] = useState(true);
  const textStyle = {
    p: {
      fontSize: '16px !important',
      marginBottom: '20px',
    },
    a: { textDecoration: 'underline' },
    h3: {
      fontFamily: 'FedraSansStd-medium',
      fontWeight: '500',
      fontSize: { base: '18px', md: '20px' },
      marginBottom: '13px',
    },
    'p strong': '16px !important',
  };
  return (
    <Box
      id="tab-content-1"
      className="tab-content"
      pb="16px"
      borderBottom={borderBottom && '1px solid #979797'}
      m="0 auto"
      maxW={{ base: '90%', md: '790px' }}
    >
      <Box
        m={{ base: '35px 0 0 0' }}
        display="flex"
        flexDirection={{ base: 'column', sm: 'row' }}
      >
        <Box m={{ base: '0 0 40px 0', sm: 'unset' }}>
          <LazyLoadImageComponent
            src={tabContent?.thumbnail?.url}
            alt={tabContent?.thumbnail?.alt}
            title={tabContent?.thumbnail?.title}
          />
        </Box>
        <Box
          display="flex"
          margin="0 0 0 15px"
          w={{ base: '100%', md: '328px' }}
          borderBottom="solid 1px #E4A100"
          alignSelf="end"
          padding={{ base: '0 0 7px 0' }}
        >
          <a name="tab-1c" />
          <Text
            as="h4"
            color="#000"
            fontSize={{ base: '20px', md: '28px' }}
            fontFamily="FedraSansStd-A-medium"
            fontWeight="500"
            {...SadhanaContentSt[lang].title}
          >
            {tabContent?.title && (
              <Text
                as="span"
                display={{
                  base: 'inline-block',
                  md: 'block',
                }}
                pr="10px"
              >
                {tabContent?.title}
              </Text>
            )}
            {/* <Text as="span">
        {sadhanaData?.[4]?.titleSubtext}
      </Text> */}
          </Text>
        </Box>
      </Box>
      <Box
        color="#000000"
        fontSize={{ base: '16px', md: '18px' }}
        fontFamily="FedraSansStd-book"
        m={{
          lg: '20px 0 0 0px',
          md: '20px 0 0 0px',
          sm: '20px 0 0 0',
        }}
        className="sadhana_list tabcontent"
      >
        <StructuredTextParser
          str={render(tabContent?.description)}
          region={region}
          lang={lang}
          sx={textStyle}
          style={'donateStyle'}
          bgTheme={'dark'}
          // px="20px"
          fontFamily="FedraSansStd-book"
          maxW="100%"
        />
        {tabContent?.buttonText && tabContent?.rightAlignedText && (
          <>
            <Collapse in={!readMore} animateOpacity duration={20000}>
              {/* <Box
              pb="30px"
              textAlign={textAlign || 'left'}
            > */}
              <StructuredTextParser
                str={render(tabContent?.moreDetailsText)}
                region={region}
                lang={lang}
                id="tab_panel_text"
                sx={textStyle}
                style={'donateStyle'}
                fontFamily="FedraSansStd-book"
                bgTheme={'dark'}
                // px="20px"
                maxW="100%"
              />
            </Collapse>
            <Center>
              <Button
                variant="link"
                // display="flex"
                display="flex"
                alignItems={'center'}
                mb="20px"
                fontFamily="FedraSansStd-medium"
                bgColor="transparent"
                border="none"
                color="#CA4E2A"
                fontSize="18px !important"
                padding="0px"
                textDecoration="none !important"
                transition="none !important"
                _hover={{
                  textDecoration: 'none',
                  bgColor: 'none',
                  color: '#983C21',
                }}
                textAlign="center"
                width="auto"
                onClick={() => setReadMore(!readMore ? true : false)}
                m="0 auto"
                _focus={{ boxShadow: 'none' }}
                mt={{ base: '10px', sm: '10px', md: '-10px' }}
              >
                {readMore
                  ? tabContent?.buttonText
                  : tabContent?.rightAlignedText}

                {readMore ? (
                  <ChevronDownIcon w={7} h={6} />
                ) : (
                  <ChevronUpIcon w={7} h={6} />
                )}
              </Button>
            </Center>
          </>
        )}
      </Box>
      <StructuredTextParser
        str={render(tabContent?.additionalText)}
        region={region}
        lang={lang}
        sx={textStyle}
        bgTheme={'dark'}
        fontFamily="FedraSansStd-book"
        style="donateStyle"
        textAlign="center"
        // px="20px"
        maxW="100%"
      />
      <style global jsx>
        {`
          .structured-content-dark ul li p strong {
            font-size: 16px !important;
          }
          .structured-content-dark p strong {
            font-size: 16px !important;
          }
          .structured-content-dark strong {
            font-size: 16px !important;
          }
        `}
      </style>
    </Box>
  );
};

export default TabPanelCard;
